import {
  anchorClassNames,
  legacyClassNames,
} from "@/react/helpers/cssAnchorHelpers";

export default function EmptyState({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) {
  return (
    <div className={legacyClassNames("profile-drawer__empty")}>
      <div className={anchorClassNames("profile-drawer__empty__title")}>
        {title}
      </div>
      <div className={anchorClassNames("profile-drawer__empty__subtitle")}>
        {subtitle}
      </div>
    </div>
  );
}
